/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


		//Se estivermos na homepage
		if ($('body.home').length > 0){
			//Se não estivermos na homepage
		}else{
			$(window).on('load scroll', function() {
				var width = window.innerWidth;
				
				var sticky_menu = $('.header-container'),
					scroll = $(window).scrollTop();
				if (scroll >= 400){
					sticky_menu.addClass('fixed-menu');
					sticky_menu.addClass('header-dark-elements');
					$('.header-container .logo').addClass('logo-out');
					$('.header-container .logo-dark').addClass('logo-dark-in');
					$('.header-container .hamburger-container').addClass('hamburger-container-scroll');
					$('.header-container .fa-search').addClass('fa-search-scroll');
					$('.header-container .nav-primary').addClass('nav-primary-scroll');
					$('.header-container .flag-container').addClass('flag-container-scroll');
					if (width <= 768){
						
					}else{
						//sticky_menu.removeClass('fixed-menu');
					}
					
				}else{
					sticky_menu.removeClass('fixed-menu');
					sticky_menu.removeClass('header-dark-elements');
					$('.header-container .logo').removeClass('logo-out');
					$('.header-container .logo-dark').removeClass('logo-dark-in');
					$('.header-container .hamburger-container').removeClass('hamburger-container-scroll');
					$('.header-container .fa-search').removeClass('fa-search-scroll');
					$('.header-container .nav-primary').removeClass('nav-primary-scroll');
					$('.header-container .flag-container').removeClass('flag-container-scroll');
				}
			});
		}

		//Prevenir funcionamento do link por default quando #
	$("a[href='#']").click(function(event){
		event.preventDefault();
	  });
	 /** WOW JS */
	 
	 var wow = new WOW(
		{
		  boxClass:     'wow',      // animated element css class (default is wow)
		  animateClass: 'animatedClass', // animation css class (default is animated)
		  offset:       0,          // distance to the element when triggering the animation (default is 0)
		  mobile:       true,       // trigger animations on mobile devices (default is true)
		  live:         true,       // act on asynchronously loaded content (default is true)
		  callback:     function(box) {
			// the callback is fired every time an animation is started
			// the argument that is passed in is the DOM node being animated
		  },
		  scrollContainer: null,    // optional scroll container selector, otherwise use window,
		  resetAnimation: true,     // reset animation on end (default is true)
		}
	  );
	  wow.init();

		/*Adicionar números aos items de menu hamburger */
		$( ".hamburger-nav li" ).each(function( index ) {
			$menuIndex = index+1;
			$(this).find('a').prepend('<span class="number">0'+ $menuIndex+'</span><span class="circle-item"></span>' );
			$(this).attr('cursor-hamburger', 'hamburger-arrow');
			//console.log( '0'+ $menuIndex + ": " + $( this ).text() );
		  });

		 /**
		   * Antes e Depois
		   */
	  //https://www.cssscript.com/image-comparison-slider-before-after/
	  var elsH = document.querySelectorAll(".image-spliter .mover");
	  var i = elsH.length;
	  /* jshint ignore:start */
	  while (i--) {
		  var moverWidth = elsH[i].getBoundingClientRect().width;
		  var imgLeft = elsH[i].nextElementSibling;
		  var width = imgLeft.getBoundingClientRect().width;
		  var height = imgLeft.getBoundingClientRect().height;
		  elsH[i].style.left = width / 2 - moverWidth / 2 + 'px';
		  imgLeft.style.clip = "rect(0px, " + width / 2 + "px, " + height + "px, 0px)";
		  imgLeft.style.clip = "rect(0px, " + width / 2 + "px, 999px, 0px)";
		  var mouseDownX = 0;
		  var X;
		  elsH[i].addEventListener("mousedown", function(e) {
			  X = e.clientX;
			  mouseDownX = 1;
		  });
		  elsH[i].addEventListener("mouseup", function(e) {
			  mouseDownX = 0;
		  });
		  elsH[i].addEventListener("mouseout", function(e) {
			  mouseDownX = 0;
		  });
  
		  elsH[i].addEventListener("touchstart", function(e) {
			  X = e.touches[0].clientX;
			  mouseDownX = 1;
		  });
		  elsH[i].addEventListener("touchend", function(e) {
			  mouseDownX = 0;
		  });
  
		  elsH[i].addEventListener("mousemove", function(e) {
			  if (mouseDownX) {
				  this.style.left = parseInt(this.style.left) + (event.clientX - X) + "px";
				  X = event.clientX;
				  this.nextElementSibling.style.clip = "rect(0px, " + (this.getBoundingClientRect().width / 2 + parseInt(this.style.left)) + "px, " + this.getBoundingClientRect().height + "px, 0px)";
			  }
		  });
  
		  elsH[i].addEventListener("touchmove", function(e) {
			  if (mouseDownX) {
				  this.style.left = parseInt(this.style.left) + (e.touches[0].clientX - X) + "px";
				  X = e.touches[0].clientX;
				  this.nextElementSibling.style.clip = "rect(0px, " + (this.getBoundingClientRect().width / 2 + parseInt(this.style.left)) + "px, " + this.getBoundingClientRect().height + "px, 0px)";
			  }
		  });
	  }
	  /* jshint ignore:end */
  
  
	  window.addEventListener("resize", function(f) {
		  var elsHre = document.querySelectorAll(".image-spliter .mover");
		  var ii = elsHre.length;
		  while (ii--) {
			  var moverWidth = elsHre[ii].getBoundingClientRect().width;
			  var imgLeft = elsHre[ii].nextElementSibling;
			  var width = imgLeft.getBoundingClientRect().width;
			  var height = imgLeft.getBoundingClientRect().height;
			  elsHre[ii].style.left = width / 2 - moverWidth / 2 + 'px';
			  imgLeft.style.clip = "rect(0px, " + width / 2 + "px, " + height + "px, 0px)";
		  }
	  });
  
	  /** Fim de Antes e depois */

		
		jQuery(document).ready(function( $ ) {
			
			
			var arrowSearch = $('.search-popup-container').data('arrow');
			var placeholderAlternative = $('.search-popup-container').data('placeholder');
			//Substitui o placeholder do search em algumas caixas de input
			$(".search-404 .proinput input, .search-header .proinput input").attr("placeholder", placeholderAlternative);
			//Substitui o svg por uma imagem personalizada, no elemento de submit form
			$('.search-popup-container .promagnifier .innericon, .search-404 .promagnifier .innericon').empty('svg');
			$('.search-popup-container .promagnifier .innericon, .search-404 .promagnifier .innericon').append('<img class="arrow-search" src="'+arrowSearch+'"  />');
			
			
			//Click na lupa
			$(".fa-search").on("click",function(e){
				$( ".hamburger-menu-container" ).fadeIn( "slow", function() {});
				$(this).addClass('hamburger-container-opened');
				$(".hamburger-menu-container").addClass('hamburger-expanded');
				$('.header-container').addClass('header-on-top');
				$('.hamburger-menu-nav-container').removeClass('open-itens');
				$('.hamburger-container-inner-menu').addClass('hamburger-container-inner-menu-animated');
				$('.search-popup-container').fadeIn( "slow", function() {});
				e.stopPropagation();
			});
			//Click no menu hamburger
			$(".hamburger-container").on("click",function(e){
				$( ".hamburger-menu-container" ).fadeIn( "slow", function() {});
				$(this).addClass('hamburger-container-opened');
				$(".hamburger-menu-container").addClass('hamburger-expanded');
				$('.header-container').addClass('header-on-top');
				$('.hamburger-menu-nav-container').addClass('open-itens');
				$('.hamburger-container-inner-menu').addClass('hamburger-container-inner-menu-animated');
				e.stopPropagation();
			});
			$(".hamburger-container-inner-menu").on("click",function(e){
				$( ".hamburger-menu-container" ).fadeOut( "slow", function() {});
				//Para que a div quando desaparece, o menu não salte de display flex para block e causar mini bug na visualização
				//setTimeout(function() { 
					$(".hamburger-menu-container").removeClass('hamburger-expanded');
				//}, 2000);
				$('.hamburger-container-inner-menu').removeClass('hamburger-container-inner-menu-animated');
				$('.hamburger-menu-nav-container').removeClass('open-itens');
				$('.search-popup-container').fadeOut( "slow", function() {});
				e.stopPropagation();
			});
			$(document).click(function(event) {
				if(!$(event.target).closest('.hamburger-menu-container').length) {
					if($('.hamburger-menu-container').is(":visible")) {
						$('.hamburger-menu-container').fadeOut(300 , function(){
							
						});
						$(".hamburger-menu-container").removeClass('hamburger-expanded');
					}
				}       
			});
		});





		//Activa círculo à volta de qualquer elemento que tenha o atributo cursor-class="arrow"
		//https://codepen.io/mf7/pen/bGWeXaW	
		var cursor = document.querySelector('#cursor');
		var cursorCircle = cursor.querySelector('.cursor__circle');
		var mouse = {
			x: -100,
			y: -100
		}; // mouse pointer's coordinates

		var pos = {
			x: 0,
			y: 0
		}; // cursor's coordinates

		var speed = 0.1; // between 0 and 1

		var updateCoordinates = function updateCoordinates(e) {
			mouse.x = e.clientX;
			mouse.y = e.clientY;
		};

		window.addEventListener('mousemove', updateCoordinates);

		function getAngle(diffX, diffY) {
			return Math.atan2(diffY, diffX) * 180 / Math.PI;
		}

		function getSqueeze(diffX, diffY) {
			var distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
			var maxSqueeze = 0.15;
			var accelerator = 1500;
			return Math.min(distance / accelerator, maxSqueeze);
		}

		var updateCursor = function updateCursor() {
			var diffX = Math.round(mouse.x - pos.x);
			var diffY = Math.round(mouse.y - pos.y);
			pos.x += diffX * speed;
			pos.y += diffY * speed;
			var angle = getAngle(diffX, diffY);
			var squeeze = getSqueeze(diffX, diffY);
			var scale = 'scale(' + (1 + squeeze) + ', ' + (1 - squeeze) + ')';
			var rotate = 'rotate(' + angle + 'deg)';
			var translate = 'translate3d(' + pos.x + 'px ,' + pos.y + 'px, 0)';
			cursor.style.transform = translate;
			cursorCircle.style.transform =  scale;
		};

		function loop() {
			updateCursor();
			requestAnimationFrame(loop);
		}

		requestAnimationFrame(loop);
		var cursorModifiers = document.querySelectorAll('[cursor-class]');
		cursorModifiers.forEach(function (curosrModifier) {
			curosrModifier.addEventListener('mouseenter', function () {
				var className = this.getAttribute('cursor-class');
				cursor.classList.add(className);
			});
			curosrModifier.addEventListener('mouseleave', function () {
				var className = this.getAttribute('cursor-class');
				cursor.classList.remove(className);
			});
		});

		var cursorModifierss = document.querySelectorAll('[cursor-classs]');
		cursorModifierss.forEach(function (curosrModifier) {
			curosrModifier.addEventListener('mouseenter', function () {
				var className = this.getAttribute('cursor-classs');
				cursor.classList.add(className);
			});
			curosrModifier.addEventListener('mouseleave', function () {
				var className = this.getAttribute('cursor-classs');
				cursor.classList.remove(className);
			});
		});
		
		var cursorModifiersHamb = document.querySelectorAll('[cursor-hamburger]');
		cursorModifiersHamb.forEach(function (curosrModifier) {
			curosrModifier.addEventListener('mouseenter', function () {
				var className = this.getAttribute('cursor-hamburger');
				cursor.classList.add(className);
			});
			curosrModifier.addEventListener('mouseleave', function () {
				var className = this.getAttribute('cursor-hamburger');
				cursor.classList.remove(className);
			});
		});
		//Para os tabs em single service
		var cursorModifiersTab = document.querySelectorAll('[cursor-tab]');
		cursorModifiersTab.forEach(function (curosrModifier) {
			curosrModifier.addEventListener('mouseenter', function () {
				var className = this.getAttribute('cursor-tab');
				cursor.classList.add(className);
			});
			curosrModifier.addEventListener('mouseleave', function () {
				var className = this.getAttribute('cursor-tab');
				cursor.classList.remove(className);
			});
		});

		//Para o slider drag nos projetos
		var cursorModifiersTab = document.querySelectorAll('[cursor-project-drag]');
		cursorModifiersTab.forEach(function (curosrModifier) {
			curosrModifier.addEventListener('mouseenter', function () {
				var className = this.getAttribute('cursor-project-drag');
				cursor.classList.add(className);
			});
			curosrModifier.addEventListener('mouseleave', function () {
				var className = this.getAttribute('cursor-project-drag');
				cursor.classList.remove(className);
			});
		});
		$(document).on({
			mouseenter: function () {
				//stuff to do on mouse enter
				$('.cursor-project-drag').addClass('hide-cursor');
			},
			mouseleave: function () {
				//stuff to do on mouse leave
				$('.cursor-project-drag').removeClass('hide-cursor');
			}
		}, ".circle"); //pass the element as an argument to .on
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
		init: function() {
			// JavaScript to be fired on the home page
			$(document).on({
				mouseenter: function () {
					//stuff to do on mouse enter
					$(this).find('.cta-link').addClass('show-link');
				},
				mouseleave: function () {
					//stuff to do on mouse leave
					$(this).find('.cta-link').removeClass('show-link');
				}
			}, ".cta-link-parent"); //pass the element as an argument to .on
			$(document).on({
				mouseenter: function () {
					//stuff to do on mouse enter
					setTimeout(function() { 
						$('.project-title').addClass('project-title-off');
						$('.slider-image img').addClass('image-color');
					}, 1000);
					setTimeout(function() { 
						$('.project-title').addClass('display-none');
					}, 1500);
				},
				mouseleave: function () {
					//stuff to do on mouse leave
					//$(this).find('.cta-link').removeClass('show-link');
				}
			}, ".project-title"); //pass the element as an argument to .on

			$(document).on({
				mouseenter: function () {
					//stuff to do on mouse enter
					
				},
				mouseleave: function () {
					//stuff to do on mouse leave
					$('.project-title').removeClass('display-none');
					setTimeout(function() { 
						$('.project-title').removeClass('project-title-off');
						$('.slider-image img').removeClass('image-color');
					}, 1000);
					
					
				}
			}, ".link-project"); //pass the element as an argument to .on

			$('.project-title').on('mouseover',function(){
				/*setTimeout(function() { 
					$(this).addClass('project-title-off');
				}, 1000);
				$(this).addClass('project-title-off');*/
				
			});

			// SIGNATURE PROGRESS
			function moveProgressBar() {
			console.log("moveProgressBar");
				var getPercent = ($('.progress-wrap').data('progress-percent') / 100);
				var getProgressWrapWidth = $('.progress-wrap').width();
				var progressTotal = getPercent * getProgressWrapWidth;
				var animationLength = 38000;
				
				// on page load, animate percentage bar to data percentage length
				// .stop() used to prevent animation queueing
				$('.progress-bar').stop().animate({
					width: progressTotal
				}, animationLength);
			}

			moveProgressBar();
			// on browser resize...
			$(window).resize(function() {
				moveProgressBar();
			});

			//Animação para Homepage, primeira secção - Foco de luz
			//Se existir videojs na homepage o foco de luz não será criado
			var video = $('.video-js');
			//Se não existir videojs na homepage, criar foco
			if(!video.length){
				$(document).mousemove(function(e){
					var X = e.pageX;
					var Y = e.pageY;
					$('.focus').css('background','radial-gradient(circle at '+X+'px '+Y+'px, transparent, rgba(0,0,0, 0.7) 30% )');
				});
			}else{
				//Se existir videojs na homepage não criar foco e adicionar class para não cobrir os controles de vídeo
				$('.focus').addClass('focus-height-video');
			}
			
			
			  //https://stackoverflow.com/questions/23136041/how-do-i-scroll-to-a-specific-section-with-a-link-using-full-page-js/23136819#23136819
			$('#fullpage').fullpage({
				anchors: ['section1', 'section2', 'section3', 'section4','section5', 'section6'],
				//normalScrollElements: '.video-js',
				//scrollBar:true,
				responsiveWidth: 992,
				//options here
				//autoScrolling:false,
				//sectionSelector: '.section',
				//verticalCentered: false,
				//navigation: true,
				afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){
					//do whatever here
					//console.log(slideIndex) +1;
					//$(body).append(slideIndex);
				}, 
				onLeave: function(origin, destination, direction){
					var leavingSection = this;
			
					//after leaving section 2
					//console.log(origin.index);
					//console.log(direction);
					if(origin.index === 0 && direction ==='down'){
						//alert("Going to section 3!");
						//console.log('ir para secção 3');
						$('.total-slides').addClass('dark-color');
						$('.slide-current').addClass('slide-current-3');
					}else if(origin.index === 1 && direction ==='down'){
						//alert("Going to section 3!");
						//console.log('ir para secção 4');
						$('.slide-current').addClass('slide-current-3');
					}else if(origin.index === 2 && direction ==='down'){
						$('.slide-current').addClass('slide-current-3');
					}else if(origin.index === 3 && direction ==='down'){
						$('.slide-current').addClass('slide-current-3');
					}else if(origin.index === 4 && direction ==='down'){
						$('.slide-current').addClass('slide-current-3');
					}
			
					else if(origin.index === 1 && direction === 'up'){
						//alert("Going to section 1!");
						$('.slide-current').addClass('slide-current-up');
						
					}else if(origin.index === 2 && direction === 'up'){
						//alert("Going to section 1!");
						$('.slide-current').addClass('slide-current-up');
					}else if(origin.index === 3 && direction === 'up'){
						//alert("Going to section 1!");
						$('.slide-current').addClass('slide-current-up');
					}
				},
				afterLoad: function(anchorLink, index){
					var slideNumber = $('.fp-section.active').index()+1;
					var slideBefore = $('.fp-section.active').index();
					var formattedSlideNumber = ("0" + slideNumber).slice(-2);
					var numSections = $('.fp-section').length;
					var formattedNumSections = ("0" + numSections).slice(-2);
					if(slideNumber === 1){
						//Primeiro slider
						setTimeout(function() { 
							$('.hidden-anchor')[0].click(); 
						}, 20000);
						//https://stackoverflow.com/questions/8043026/how-to-format-numbers-by-prepending-0-to-single-digit-numbers
						$('.num').html('<span class="slide-current slide-current-3-1">' +formattedSlideNumber+'</span>' +'<span class="separator"></span>' +'<span class="total-slides">' +formattedNumSections+'</span>' );
						//console.log('cheguei À secção 1');
						$('.normal-header .logo').removeClass('logo-out');
						$('.normal-header .logo-dark').removeClass('logo-dark-in');
						$('header.normal-header').removeClass('header-no-margin');
						$('.normal-header .hamburger-container').removeClass('hamburger-container-scroll');
						$('.normal-header .fa-search').removeClass('fa-search-scroll');
						$('.normal-header .nav-primary').removeClass('nav-primary-scroll');
						$('.normal-header .flag-container').removeClass('flag-container-scroll');
					}else if(slideNumber === 2 ){
						//Se passamos logo para as secções seguintes, não faz sentido deixar o click na anchor ligada para a secção 2
						$('.hidden-anchor').removeAttr("href");
						//segundo slider
						$('.num').html('<span class="slide-current slide-current-3-1 dark-color">' +formattedSlideNumber+'</span>' +'<span class="separator dark-separator"></span>' +'<span class="total-slides dark-color">' +formattedNumSections+'</span>' );
						$('header.normal-header').addClass('header-no-margin');
						$('.normal-header .logo').addClass('logo-out');
						$('.normal-header .logo-dark').addClass('logo-dark-in');
						$('.normal-header .hamburger-container').addClass('hamburger-container-scroll');
						$('.normal-header .fa-search').addClass('fa-search-scroll');
						$('.normal-header .nav-primary').addClass('nav-primary-scroll');
						$('.normal-header .flag-container').addClass('flag-container-scroll');
					}else if(slideNumber === 3){
						//terceiro slider
						$('.num').html('<span class="slide-current slide-current-3-1 dark-color">' +formattedSlideNumber+'</span>' +'<span class="separator dark-separator"></span>' +'<span class="total-slides dark-color">' +formattedNumSections+'</span>' );
						$('header.normal-header').addClass('header-no-margin');
						$('.normal-header .logo').addClass('logo-out');
						$('.normal-header .logo-dark').addClass('logo-dark-in');
						$('.normal-header .hamburger-container').addClass('hamburger-container-scroll');
						$('.normal-header .fa-search').addClass('fa-search-scroll');
						$('.normal-header .nav-primary').addClass('nav-primary-scroll');
						$('.normal-header .flag-container').addClass('flag-container-scroll');
					}else if(slideNumber === 4){
						//quarto slider
						$('.num').html('<span class="slide-current slide-current-3-1 dark-color">' +formattedSlideNumber+'</span>' +'<span class="separator dark-separator"></span>' +'<span class="total-slides dark-color">' +formattedNumSections+'</span>' );
						$('header.normal-header').addClass('header-no-margin');
						$('.normal-header .logo').addClass('logo-out');
						$('.normal-header .logo-dark').addClass('logo-dark-in');
						$('.normal-header .hamburger-container').addClass('hamburger-container-scroll');
						$('.normal-header .fa-search').addClass('fa-search-scroll');
						$('.normal-header .nav-primary').addClass('nav-primary-scroll');
						$('.normal-header .flag-container').addClass('flag-container-scroll');
					}else if(slideNumber === 5){
						//quarto slider
						$('.num').html('<span class="slide-current slide-current-3-1">' +formattedSlideNumber+'</span>' +'<span class="separator"></span>' +'<span class="total-slides">' +formattedNumSections+'</span>' );
						$('header.normal-header').addClass('header-no-margin');
						$('.normal-header .logo').addClass('logo-out');
						$('.normal-header .logo-dark').addClass('logo-dark-in');
						$('.normal-header .hamburger-container').addClass('hamburger-container-scroll');
						$('.normal-header .fa-search').addClass('fa-search-scroll');
						$('.normal-header .nav-primary').addClass('nav-primary-scroll');
						$('.normal-header .flag-container').addClass('flag-container-scroll');
					}else if(slideNumber === 6){
						//quarto slider
						$('.num').html('<span class="slide-current slide-current-3-1 dark-color">' +formattedSlideNumber+'</span>' +'<span class="separator dark-separator"></span>' +'<span class="total-slides dark-color">' +formattedNumSections+'</span>' );
						$('header.normal-header').addClass('header-no-margin');
						$('.normal-header .logo').addClass('logo-out');
						$('.normal-header .logo-dark').addClass('logo-dark-in');
						$('.normal-header .hamburger-container').addClass('hamburger-container-scroll');
						$('.normal-header .fa-search').addClass('fa-search-scroll');
						$('.normal-header .nav-primary').addClass('nav-primary-scroll');
						$('.normal-header .flag-container').addClass('flag-container-scroll');
					}else{
						$('.num').html(formattedSlideNumber +'<span class="separator"></span>' +formattedNumSections );
				
					}
					//console.log(numSections);
					
				 //do whatever here
					//$(body).append(slideNumber);
				}
			});

			//Slider do banner
			$mainBanner = $('.main-banner-slider-container');
			$mainBanner.each( function(){
			  $(this).slick({
				// normal options...
				infinite: true,
				slidesToShow:1,
				slidesToScroll: 1,
				arrows: false,
				//adaptiveHeight: true,
				//variableWidth: true,
				autoplay: true,
				centerPadding: '0',
				draggable: true,
				swipe: true,
				centerMode:false,
				//pauseOnDotsHover: true,
				slide:'.main-banner-slider-container-inner',
				fade: true,
				cssEase: 'linear',
				speed: 1500,
				rows: 0,
				dots: false,
				//prevArrow: $(".fa-arrow-left"),
				//nextArrow: $(".fa-arrow-right"),
				
				// Breakpoints
				responsive: [{
				  breakpoint: 990,
				  settings: {
				  slidesToShow: 1,
				  infinite: true,
				  }
			  
				}]
			  }); 
			});

			//Slider do banner
			$homeProjects = $('.project-home-container');
			$homeProjects.on('init', function(event, slick, direction,currentSlide,index) {
				var prev_slick_img = $(this).find('.slick-current').prev('.slick-slide').find('.slider-image img').attr('src');
				var last_slick_img = $(this).find('.slick-slide').last().find('.slider-image img').attr('src');
				//console.log(prev_slick_img);
				//var currentSlideDom=$(slick.currentSlide);
				//console.log(slick.currentSlide);
				if(slick.currentSlide === 0){
					//console.log(slick.currentSlide)
					//Devido a estarmos a usar opção de fade no slider, temos que ir buscar a opção do útimo slider para que apareça no primeiro
					$('.prev-image-col').html('<img class="img-fluid prev-image" src=" '+ last_slick_img +'">');
				}else{
					//console.log('outro slider')
					$('.prev-image-col').html('<img class="img-fluid prev-image" src=" '+ prev_slick_img +'">');
				}
				//console.log(currentSlideDom);
				
				/*var link = $("#me").parent("div").prev("h3").find("b");
				console.log(link.text());*/
			  });
			$homeProjects.each( function(){
			  $(this).slick({
				// normal options...
				infinite: true,
				slidesToShow:1,
				slidesToScroll: 1,
				arrows: true,
				//adaptiveHeight: true,
				//variableWidth: true,
				autoplay: false,
				centerPadding: '0',
				draggable: true,
				swipe: true,
				centerMode:false,
				//pauseOnDotsHover: true,
				slide:'.project-home-container-inner',
				fade: true,
				//cssEase: 'linear',
				cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
				touchThreshold: 100,
				speed: 1500,
				rows: 0,
				dots: false,
				prevArrow: $(".arrow-left"),
				nextArrow: $(".arrow-right"),
				
				// Breakpoints
				responsive: [{
				  breakpoint: 990,
				  settings: {
				  slidesToShow: 1,
				  infinite: true,
				  }
			  
				}]
			  }); 
			});

			$homeProjects.on('afterChange', function(event, slick, currentSlide, nextSlide){
				var prev_slick_img = $(this).find('.slick-current').prev('.slick-slide').find('.slider-image img').attr('src');
				var last_slick_img = $(this).find('.slick-slide').last().find('.slider-image img').attr('src');
				//console.log(prev_slick_img);
				//var currentSlideDom=$(slick.currentSlide);
				//console.log(slick.currentSlide);
				if(slick.currentSlide === 0){
					//console.log(slick.currentSlide)
					//Devido a estarmos a usar opção de fade no slider, temos que ir buscar a opção do útimo slider para que apareça no primeiro
					$('.prev-image-col').html('<img class="img-fluid prev-image" src=" '+ last_slick_img +'">');
				}else{
					//console.log('outro slider')
					$('.prev-image-col').html('<img class="img-fluid prev-image" src=" '+ prev_slick_img +'">');
				}
			});
			//Para quando passamos com o rato por cima de cada imagem de cliente, irá surgir o popup com testemunho
			$(document).on({
				mouseenter: function () {
					//stuff to do on mouse enter
					/*$( ".client-testimonial-popup-container" ).fadeIn( "slow", function() {
					
					});
					$('.client-testimonial-popup-container').addClass('client-testimonial-popup-on');
					$client_link_label = $(this).data('link-label');
					$client_link = $(this).data('link');
					$client_title = $(this).data('title');
					$client_image = $(this).data('image');
					$client_testimonial = $(this).data('testimonial');
					$('.client-testimonial-popup-inner .content-client').html(
						'<div class="client-image"><img src="'+ $client_image +'"></div>'+
						'<div class="client-testimonial"><div class="client-link"><a href="'+ $client_link +'">'+ 
						$client_link_label +'</a></div><div class="client-title">'+ 
						$client_title +'</div><div class="testimonial">'+$client_testimonial+'</div></div>'
					);*/
				},
				mouseleave: function () {
					//stuff to do on mouse leave
					//$('.client-testimonial-popup-container').empty();
				}
			}, ".client-image-container"); //pass the element as an argument to .on
			$('.fa-times').on('click',function(){
				$( ".client-testimonial-popup-container" ).fadeOut( "fast", function() {
					
				});
				$('.client-testimonial-popup-container').removeClass('client-testimonial-popup-on');
			});

			/**Slider Serviços Homepage */
			$homeServices = $('.services-home-container-col');
			
			$homeServices.each( function(){
				$('#service-next').click(function(){
					$(this).slick('slickNext');
				  });
				$(this).slick({
				  // normal options...
				  infinite: true,
				  slidesToShow:3,
				  slidesToScroll: 1,
				  arrows: true,
				  //adaptiveHeight: true,
				  //variableWidth: true,
				  autoplay: false,
				  centerPadding: '0',
				  draggable: true,
				  swipe: true,
				  centerMode:false,
				  //pauseOnDotsHover: true,
				  slide:'.services-container-inner',
				  fade: false,
				  //cssEase: 'linear',
				  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
				  touchThreshold: 100,
				  speed: 1500,
				  rows: 0,
				  dots: false,
				  prevArrow: $(".home-services-prev"),
				  nextArrow: $(".home-services-next"),
				  
				  // Breakpoints
				  responsive: [{
					breakpoint: 990,
					settings: {
					slidesToShow: 1,
					infinite: true,
					}
				
				  }]
				  
				}); 
				
			});
			var $sliderBlog = $homeServices;
			var $progressBarBlog = $('.progress');
			var $progressBarLabelBlog = $( '.slider__label' );
			
			$sliderBlog.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
			var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
			
			$progressBarBlog
				.css('background-size', calc + '% 100%')
				.attr('aria-valuenow', calc );
			
			$progressBarLabelBlog.text( calc + '% completed' );
			});
		},
		finalize: function() {
			// JavaScript to be fired on the home page, after the init JS
		}
    },
    // About us page, note the change from about-us to about_us.
    'post_type_archive_projectos': {
		init: function() {
			// JavaScript to be fired on the about us page
			$(document).on({
				mouseenter: function () {
					//stuff to do on mouse enter
					setTimeout(function() { 
						$('.project-title').addClass('project-title-off');
						$('.slider-image img').addClass('image-color');
					}, 1000);
					setTimeout(function() { 
						$('.project-title').addClass('display-none');
					}, 1000);
				},
				mouseleave: function () {
					//stuff to do on mouse leave
					//$(this).find('.cta-link').removeClass('show-link');
				}
			}, ".project-title"); //pass the element as an argument to .on

			$(document).on({
				mouseenter: function () {
					//stuff to do on mouse enter
					
				},
				mouseleave: function () {
					//stuff to do on mouse leave
					$('.project-title').removeClass('display-none');
					setTimeout(function() { 
						$('.project-title').removeClass('project-title-off');
						$('.slider-image img').removeClass('image-color');
					}, 1000);
					
					
				}
			}, ".link-project"); //pass the element as an argument to .on


			/**Slider Serviços */
			$ProjectServices = $('.services-projects-container');
			
			$ProjectServices.each( function(){
				$(this).slick({
				  // normal options...
				  infinite: true,
				  slidesToShow:3,
				  slidesToScroll: 1,
				  arrows: true,
				  //adaptiveHeight: true,
				  //variableWidth: true,
				  autoplay: false,
				  centerPadding: '0',
				  draggable: true,
				  swipe: true,
				  centerMode:false,
				  //pauseOnDotsHover: true,
				  slide:'.services-container-inner',
				  fade: false,
				  //cssEase: 'linear',
				  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
				  touchThreshold: 100,
				  speed: 1500,
				  rows: 0,
				  dots: false,
				  prevArrow: $(""),
				  nextArrow: $(".home-services-next"),
				  
				  // Breakpoints
				  responsive: [{
					breakpoint: 990,
					settings: {
					slidesToShow: 1,
					infinite: true,
					}
				
				  }]
				  
				}); 
			});
		}
    },
	'single_projectos': {
		init: function() {
			/**Slider Serviços */
			$singleProjectsBeforeAfter = $('.projects-before-after-container');
			
			$singleProjectsBeforeAfter.each( function(){
				$(this).slick({
				  // normal options...
				  infinite: true,
				  slidesToShow:1,
				  slidesToScroll: 1,
				  arrows: true,
				  //adaptiveHeight: true,
				  //variableWidth: true,
				  autoplay: false,
				  centerPadding: '0',
				  draggable: false,
				  swipe: false,
				  centerMode:false,
				  //pauseOnDotsHover: true,
				  slide:'.projects-before-after-container-inner',
				  fade: false,
				  //cssEase: 'linear',
				  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
				  touchThreshold: 100,
				  speed: 1500,
				  rows: 0,
				  dots: false,
				  prevArrow: $(""),
				  nextArrow: $(".circle"),
				  
				  // Breakpoints
				  responsive: [{
					breakpoint: 990,
					settings: {
					slidesToShow: 1,
					infinite: true,
					}
				
				  }]
				  
				}); 
			});
		}
	},
	'single_servicos': {
		init: function() {
		  /**Slider single Serviços */
		  	var $status = $('.project-slider-number-info');	
			$singleServicesSlider = $('.single-services-slider-container');
			$singleServicesSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                //Transformar os números simples com zero à frente
                var i = (currentSlide ? currentSlide : 0) + 1;
                var slidertotal = slick.slideCount;
                if (i  < 9){
                  i = "0" + i;  
                }
                
                if (slidertotal  < 9){
                    slidertotal = "0" + slidertotal;
                }
                
                $status.html('<span class="current-project-number">' + i + '</span>' + '<span class="project-number-separator"> / </span> ' + slidertotal);
              });
			$singleServicesSlider.each( function(){
				$(this).slick({
				  // normal options...
				  infinite: true,
				  slidesToShow:1,
				  slidesToScroll: 1,
				  arrows: true,
				  //adaptiveHeight: true,
				  //variableWidth: true,
				  autoplay: false,
				  centerPadding: '0',
				  draggable: false,
				  swipe: false,
				  centerMode:false,
				  //pauseOnDotsHover: true,
				  slide:'.single-services-slider-container-inner',
				  fade: true,
				  //cssEase: 'linear',
				  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
				  touchThreshold: 100,
				  speed: 1500,
				  rows: 0,
				  dots: false,
				  prevArrow: $(".arrow-left"),
				  nextArrow: $(".arrow-right"),
				  
				  // Breakpoints
				  responsive: [{
					breakpoint: 990,
					settings: {
					slidesToShow: 1,
					infinite: true,
					}
				
				  }]
				  
				}); 
			});

		}
	},
	'page_template_template_blog': {
		init: function() {
			//Configuração do filtro de categorias
		  	$(".fa-filter").on("click",function(e){
				$('.section-container .description').addClass('blog-description');
				$( ".fa-filter" ).addClass('filter-off');
				
					var widthScreen = jQuery(document).width();
					//var height = jQuery(document).height();
					console.log('largura',widthScreen);
					if(widthScreen >= 990){
						setTimeout(function() { 
						$( ".fa-times" ).addClass('times-on');
						$('.blog-categories ul').fadeIn( "fast", function() {
							$('.blog-categories ul').addClass('ul-opened');
						}).css('display', 'flex');
					}, 1000);
					}else{
						//setTimeout(function() { 
							$( ".fa-times" ).addClass('times-on');
							$('.blog-categories ul').fadeIn( "fast", function() {
								$('.blog-categories ul').addClass('ul-opened');
							}).css('display', 'flex');
						//}, 1000);
					}
				
				
				//$( this ).fadeOut( "fast", function() {});
				$('.blog-categories').addClass('blog-categories-open');
				e.stopPropagation();
			});
			$(".fa-times").on("click",function(e){
				$('.section-container .description').removeClass('blog-description');
				$('.blog-categories ul').removeClass('ul-opened');
				$('.blog-categories ul').fadeOut( "fast", function() {

				}).css('display', 'none');
				$( ".fa-times" ).removeClass('times-on');
				
				setTimeout(function() { 
					
					$( ".fa-filter" ).removeClass('filter-off');
				}, 1000);
				//$( this ).fadeOut( "fast", function() {});
				$('.blog-categories').removeClass('blog-categories-open');
				e.stopPropagation();
			});
			//Fim de Configuração do filtro de categorias
		}
	},
	'page_template_template_quem_somos': {
		init: function() {
		  //Inicia os counters quando fazemos scroll até à secção
		  
			$(window).on('load scroll', function(){
				var wintop = $(window).scrollTop();
				console.log('wintop='+wintop);
				if(wintop > 450){
					$('.counter').each(function() {
						var $this = $(this),
						countTo = $this.attr('data-count');
						$({ countNum: $this.text()}).animate({
						  countNum: countTo
						},					  
						{					  
						  duration: 3000,
						  easing:'linear',
						  step: function() {
							$this.text(Math.floor(this.countNum));
						  },
						  complete: function() {
							$this.text(this.countNum);
							//alert('finished');
						  }
					  
						});  
					  
					});
				}
			});
		}
		
	},
	'archive': {
		init: function() {
			//Configuração do filtro de categorias
		  	$(".fa-filter").on("click",function(e){
				$('.section-container .description').addClass('blog-description');
				$( ".fa-filter" ).addClass('filter-off');
				
					var widthScreen = jQuery(document).width();
					//var height = jQuery(document).height();
					console.log('largura',widthScreen);
					if(widthScreen >= 990){
						setTimeout(function() { 
						$( ".fa-times" ).addClass('times-on');
						$('.blog-categories ul').fadeIn( "fast", function() {
							$('.blog-categories ul').addClass('ul-opened');
						}).css('display', 'flex');
					}, 1000);
					}else{
						//setTimeout(function() { 
							$( ".fa-times" ).addClass('times-on');
							$('.blog-categories ul').fadeIn( "fast", function() {
								$('.blog-categories ul').addClass('ul-opened');
							}).css('display', 'flex');
						//}, 1000);
					}
				
				
				//$( this ).fadeOut( "fast", function() {});
				$('.blog-categories').addClass('blog-categories-open');
				e.stopPropagation();
			});
			$(".fa-times").on("click",function(e){
				$('.section-container .description').removeClass('blog-description');
				$('.blog-categories ul').removeClass('ul-opened');
				$('.blog-categories ul').fadeOut( "fast", function() {

				}).css('display', 'none');
				$( ".fa-times" ).removeClass('times-on');
				
				setTimeout(function() { 
					
					$( ".fa-filter" ).removeClass('filter-off');
				}, 1000);
				//$( this ).fadeOut( "fast", function() {});
				$('.blog-categories').removeClass('blog-categories-open');
				e.stopPropagation();
			});
			//Fim de Configuração do filtro de categorias
		}
	},
	'about_us': {
		init: function() {
		  // JavaScript to be fired on the about us page
		}
	}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
